import { Component, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import moment from "moment";
import { FiltrosGuias } from "src/app/models/guias.model";
import { EmpresasService } from "../../services/empresas.service";

@Component({
  selector: "app-parceiro-guias-filtro",
  templateUrl: "./parceiro-guias-filtro.page.html",
  styleUrls: ["./parceiro-guias-filtro.page.scss"],
})
export class ParceiroGuiasFiltroPage implements OnInit {
  filtros: FiltrosGuias = new FiltrosGuias();
  cidadesGuias: Array<any> = [];
  empresas: any;

  AguardandoAgendamento = "Aguardando Agendamento";
  AguardandoConfirmacao = "Aguardando Confirmação";
  Agendado = "Agendado";
  Pago = "Pago";
  Atendida = "Atendida";

  CartaoCredito = "Cartão de Crédito";
  CartaoDebito = "Cartão de Débito";
  Pix = "PIX";
  Dinheiro = "Dinheiro";
  Consignado = "Consignado em Folha";

  Central = "Central";
  App = "App";
  Empresarial = "Empresarial";
  constructor(
    public modalCtrl: ModalController,
    private empresaService: EmpresasService
  ) {}

  ngOnInit() {
    this.carregarEmpresas();
  }

  carregarEmpresas() {
    return new Promise<void>((resolve, reject) => {
      this.empresaService.getAll().subscribe(
        (empresas) => {
          this.empresas = empresas;
          this.empresas.forEach((elemento) => {
            this.cidadesGuias.push({
              nomeCidade: elemento.cidade,
              id_empresa: elemento._id,
            });
            this.cidadesGuias = this.cidadesGuias.filter(function (a) {
              return (
                !this[JSON.stringify(a.nomeCidade)] &&
                (this[JSON.stringify(a.nomeCidade)] = true)
              );
            }, Object.create(null));
          });
          this.cidadesGuias.sort((a, p) =>
            a.nomeCidade < p.nomeCidade ? -1 : 1
          );
          resolve();
        },
        (error) => {
          console.error(error);
          reject();
        }
      );
    });
  }

  filtrar() {
    this.filtros.startDate = moment(this.filtros.startDate).format(
      "DD/MM/YYYY"
    );
    this.filtros.endDate = moment(this.filtros.endDate).format("DD/MM/YYYY");
    this.modalCtrl.dismiss(this.filtros);
  }
}
